<div class="thum_inner">
	<ng-container *ngIf="addOnImagePassOn">
		<img src="{{addOnImagePassOn}}" (click)="clickThumbAddOnImage()" />
	</ng-container>
	<ng-container *ngFor="let thumbnail of thumbnails; let i = index">
		<ng-container *ngIf="!thumbnail.image.includes('youtu')">
			<img src="{{ thumbnail.image }}" (click)="click_thumb(i)" [alt]="thumbnail.altText" />
		</ng-container>
		<ng-container *ngIf="thumbnail.image.includes('youtu')">
			<div class="smallVideodisplay_cont" (click)="click_thumb(i)">
				<span class="material-symbols-outlined">
					play_circle
				</span>
			</div>
		</ng-container>
	</ng-container>
</div>
